export enum VehicleProtectionBenefitType {
  COMPREHENSIVE = "Comprehensive",
  THIRD_PARTY = "ThirdParty",
  FIRE_THEFT = "FireTheft",
  BREAKDOWN = "Breakdown",
  LEGAL_EXPENSES = "LegalExpenses",
  MEDICAL_EXPENSES = "MedicalExpenses",
  KEY_COVER = "KeyCover",
  WINDSCREEN_COVER = "WindscreenCover",
  PERSONAL_BELONGINGS = "PersonalBelongings",
  HIRE_CAR = "HireCar",
  EUROPEAN_COVER = "EuropeanCover"
}
